import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=d56cbf00&"
import script from "./storage.vue?vue&type=script&lang=ts&"
export * from "./storage.vue?vue&type=script&lang=ts&"
import style0 from "./storage.vue?vue&type=style&index=0&id=d56cbf00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports